var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 3v3M18.364 5.636l-2.121 2.121M21 12h-3M18.364 18.364l-2.121-2.121M12 21v-3M5.636 18.364l2.121-2.121M3 12h3M5.636 5.636l2.121 2.121","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Spinner.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = Spinner;

Spinner.default = Spinner;
